import React from 'react';
import { AdminsTab } from './AdminsTab';
import { AllMembersTab } from './AllMembersTab';

export const MembersTab = ({ admins, allMembers, activeChildTab }) => (
  <>
    {activeChildTab === 0 ? (
      <AdminsTab admins={admins} />
    ) : activeChildTab === 1 ? (
      <AllMembersTab allMembers={allMembers} />
    ) : null}
  </>
);
